import { DateTime, Duration, DurationLikeObject } from 'luxon';

export const isWithinThresholdFromNow = ({
  dateString,
  threshold,
}: {
  dateString: string;
  threshold: DurationLikeObject;
}) => {
  const now = DateTime.utc();
  const target = DateTime.fromISO(dateString, { zone: 'utc' });
  const difference = target.diff(now).as('milliseconds');
  const thresholdMs = Duration.fromObject(threshold).as('milliseconds');

  return difference <= thresholdMs;
};
